import { ECountryLocale } from '../countryLocale';
import { IWebsiteSettings } from '../model';

export const WEBSITE_SETTINGS: IWebsiteSettings[] = [
  { hostname: 'www.notino.com', domainName: 'notino.com', locale: ECountryLocale.UNDEFINED },
  { hostname: 'www.notino.cz', domainName: 'notino.cz', locale: ECountryLocale.CZECHIA },
  { hostname: 'www.notino.sk', domainName: 'notino.sk', locale: ECountryLocale.SLOVAKIA },
  { hostname: 'www.notino.pl', domainName: 'notino.pl', locale: ECountryLocale.POLAND },
  { hostname: 'www.notino.de', domainName: 'notino.de', locale: ECountryLocale.GERMANY },
  { hostname: 'www.notino.at', domainName: 'notino.at', locale: ECountryLocale.AUSTRIA },
  { hostname: 'www.notino.hu', domainName: 'notino.hu', locale: ECountryLocale.HUNGARY },
  { hostname: 'www.notino.es', domainName: 'notino.es', locale: ECountryLocale.SPAIN },
  { hostname: 'www.notino.pt', domainName: 'notino.pt', locale: ECountryLocale.PORTUGAL },
  { hostname: 'www.notino.co.uk', domainName: 'notino.co.uk', locale: ECountryLocale.BRITAIN },
  { hostname: 'www.notino.fr', domainName: 'notino.fr', locale: ECountryLocale.FRANCE },
  { hostname: 'www.notino.it', domainName: 'notino.it', locale: ECountryLocale.ITALY },
  { hostname: 'www.notino.nl', domainName: 'notino.nl', locale: ECountryLocale.NETHERLANDS },
  { hostname: 'www.notino.be', domainName: 'notino.be', locale: ECountryLocale.BELGIUM },
  { hostname: 'www.notino.hr', domainName: 'notino.hr', locale: ECountryLocale.CROATIA },
  { hostname: 'www.notino.se', domainName: 'notino.se', locale: ECountryLocale.SWEDEN },
  { hostname: 'www.notino.dk', domainName: 'notino.dk', locale: ECountryLocale.DENMARK },
  { hostname: 'www.notino.fi', domainName: 'notino.fi', locale: ECountryLocale.FINLAND },
  { hostname: 'www.notino.gr', domainName: 'notino.gr', locale: ECountryLocale.GREECE },
  { hostname: 'www.notino.bg', domainName: 'notino.bg', locale: ECountryLocale.BULGARIA },
  { hostname: 'www.notino.ua', domainName: 'notino.ua', locale: ECountryLocale.UKRAINE },
  { hostname: 'www.notino.si', domainName: 'notino.si', locale: ECountryLocale.SLOVENIA },
  { hostname: 'www.notino.ro', domainName: 'notino.ro', locale: ECountryLocale.ROMANIA },
  { hostname: 'www.notino.ch', domainName: 'notino.ch', locale: ECountryLocale.SWITZERLAND },
  { hostname: 'www.notino.ru', domainName: 'notino.ru', locale: ECountryLocale.RUSSIA },
  { hostname: 'www.notino.lt', domainName: 'notino.lt', locale: ECountryLocale.LITHUANIA },
  { hostname: 'www.notino.ie', domainName: 'notino.ie', locale: ECountryLocale.IRELAND },
  { hostname: 'www.notino.lv', domainName: 'notino.lv', locale: ECountryLocale.LATVIA },
  { hostname: 'www.notino.ee', domainName: 'notino.ee', locale: ECountryLocale.ESTONIA },
];
